import { ReceptionContactDetail } from "./ReceptionContactDetail";

// 連絡先
export class ReceptionContact {
  public details: ReceptionContactDetail[];
  public note: string;

  clone(): ReceptionContact {
    const newObj = new ReceptionContact();
    newObj.details = this.details;
    newObj.note = this.note;

    return newObj;
  }
}
